/* Table of Contents
==================================================

    #Slate Default
    #Custom Velstar

==================================================
*/

/* ==========================================================================
#Slate Default
========================================================================== */

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Settings ================*/
//Create Vars that match SCSS breakpoints, defined in variables.scss.liquid file.
var screenSM = 576,
	screenMD = 768,
	screenLG = 992,
	screenXL = 1200;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Templates ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).addClass('variant-available');
        $(selectors.addToCart, this.$container).removeClass('variant-not-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('variant-not-available');
        $(selectors.addToCart, this.$container).removeClass('variant-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

	function relatedProductsProSlick(target) {
		$(target).slick({
		  infinite: true,
		  slidesToShow: 4,
          slidesToScroll: 4,
          dots: true,
			arrows:true,
			//dots: true,
			prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-left' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'></path></svg></button>",
		  nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-right' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'></path></svg></button>",
			  responsive: [
				{
				  breakpoint: 992,
				  settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				  }
				},
				{
				  breakpoint: 768,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots:false
				  }
				}
			  ]
    });

    //var stHeight = $(target + ' .slick-track').height();
	  //$(target + ' .slick-track').css('height',stHeight + 'px' );
  }

  function recentlyViewedProductsProSlick(target) {
		$(target).slick({
    	    infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
			arrows:true,
			dots: true,
			prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-left' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'></path></svg></button>",
		    nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-right' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'></path></svg></button>",
			  responsive: [
				{
				  breakpoint: 992,
				  settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				  }
				},
				{
				  breakpoint: 768,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots:false
				  }
				}
			  ]
    });

    //var stHeight = $(target + ' .slick-track').height();
	  //$(target + ' .slick-track').css('height',stHeight + 'px' );
  }

  //BG: Get the current selected colour from the product colour app and output it within the product colour title.
  function productColour() {
    var productColorName = $('.swatchProductColor.currentSwatch').attr('data-name');
    $('.product-colour-variant').text(productColorName);
  }

  //BG: once the product colour app has loaded, drop in title
  function productColourApp(nothing) {
    $('div[id*="webyze-product-colors-"]').prepend("<h3 class='product-colour-title'>Colour:<span class='product-colour-variant'></span></h3>");

    productColour();
  }

//get Query Variable
function getQueryVariable(variable) {
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}

//BG: if variant parameter is available in the URL, change the selection based on this.
function changeProductByVariantID() {
	var variantID = getQueryVariable('variant');
	//console.log(variant);

    if (variantID) {
		$('.swatch [data-variant-id="'+variantID+'"]').find('input[type="radio"]').prop("checked", true);
		//console.log('test');
    }

}

//BG: Intended to work with the 'back in stock' app. Trigger via button
function notifyApp() {
  var notifyBtn = $('.btn-notifyme'),
      addToCartBtn = $('.btn-add-to-cart'),
      addToCartBtnText = $('.btn-add-to-cart').text().trim();
      console.log(addToCartBtnText);

      //check if firstVariant has the soldout class and if so, hide add to cart btn and show notify button.
      if (addToCartBtn.hasClass('variant-not-available')) {
        if (addToCartBtnText !== "Please select a size"){
          notifyBtn.removeClass('d-none');
          addToCartBtn.addClass('d-none');

						notifyBtn.show();
						notifyBtn.css('width','calc(100% - 55px)');
						notifyBtn.css('height','60px');
						notifyBtn.css('margin-right','15px');
						notifyBtn.css('opacity','1');
        }
      }

      $('.swatch-element > label').off("click").on("click", function(){
        var variant = $(this).parent(),
            variantValue = $(this).parent().attr('data-variant-id');
        if (variant.hasClass('soldout')) {
          notifyBtn.attr('data-variant-id',variantValue);
          notifyBtn.removeClass('d-none');
          addToCartBtn.addClass('d-none');
					notifyBtn.css('width','calc(100% - 55px)');
					notifyBtn.css('margin-right','15px');
					notifyBtn.css('height','60px');
					notifyBtn.css('opacity','1');
        } else {
          notifyBtn.addClass('d-none');
          addToCartBtn.removeClass('d-none');
										console.log('3');
        }
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger via soldout size label
function notifyAppTwo() {
  var soldOutLabel = $('.soldout > label'),
      notifyBtn = $('.BIS_trigger');

      soldOutLabel.click(function(e){
        e.preventDefault();
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger when all sizes are soldout
function notifyNoSizes() {
  if (!$('.swatch-element').hasClass('available')) {
    $('.BIS_trigger').click();
  }
}

	/*
	BG: persistentCheck: The idea being to constantly check (or persistently check) if target exists, if it does, pass in an additional function that will trigger once condition is true. If condition is never true, have a timeoutTime to stop checking.
	*/
	function persistentCheck(target,targetValue,paramFunction,paramTarget,timeoutTime) {
		//console.log('persistentCheckFunction');
		var checkExist = setInterval(function() {
			//console.log('Persistently checking for: '+target);
      //keep checking to see if condition is true

     if ($(target).length > targetValue) {
				//console.log('condition is true, will no longer check.');
				//check paramFunction is actually a function
				if (typeof paramFunction == "function") {
					paramFunction(paramTarget);
				}
				//clear interval
				clearInterval(checkExist);
			}
		}, 100); // check every 100ms

		setTimeout(function(){
			//console.log('couldn\'t find target or condition wasn\'t true');
			clearInterval(checkExist);
		}, timeoutTime);
  }

  //Accordion Functionality.
function accordionToggle() {
	var accordionTitle = $('.accordion-title');

	$('.accordion-item.active .accordion-content').show();

	accordionTitle.click(function(){
		if ($(this).parent('.accordion-item').hasClass('active')) {
			$(this).parent('.accordion-item').removeClass('active');
			$(this).next('.accordion-content').slideUp();
		} else {

			$('.accordion-item').removeClass('active');
			$('.accordion-content').slideUp();

			$(this).parent('.accordion-item').addClass('active');
			$(this).next('.accordion-content').slideDown();
		}
	})
}

function sizeguideSelect() {
	var sizeTabs = $('.size-guide-frame .size-tabs li a'),
		sizeSelect = $('.size-guide-frame .size-tabs-select select'),
		sizeTable = $('.size-guide-frame table');

	$(sizeTabs).click(function(e){
		e.preventDefault();
		var tableOption = $(this).attr('data-option');

		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$(sizeSelect).val(tableOption).change();

		$(this).parent('li').addClass('active');
		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');
	});

	$(sizeSelect).on('change', function(){
		var tableOption = $(this).val();

		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$('.size-guide-frame .size-tabs li a[data-option="'+tableOption+'"]').parent('li').addClass('active');

		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');

	});

}

function sizeguideModal() {
	var closeIcon = $('.size-guide-frame .size-guide-close'),
		sizeguideOverlay = $('.size-guide-overlay'),
		sizeguideFrame = $('.size-guide-frame'),
		sizeguideOpen = $('.template-product .size-guide');

		$(closeIcon).click(function(){
			$(sizeguideFrame).removeClass('active');
			$(sizeguideOverlay).removeClass('active');
		})

		$(sizeguideOpen).click(function(){
			$(sizeguideFrame).addClass('active');
			$(sizeguideOverlay).addClass('active');
		})
}

	//BG: Only run on Product Page.
	if ($('body.template-product')) {

    //Related Products
	persistentCheck('.featured-products.related-products .featured-product',4,relatedProductsProSlick,'.featured-products.related-products .featured-products-slick',10000);

    //Recently Viewed
    persistentCheck('.featured-products.product-recently-viewed .featured-product',4,recentlyViewedProductsProSlick,'.featured-products.product-recently-viewed .featured-products-slick',10000);

    //Product Color Swatch
    persistentCheck('.swatchProductColor',1, productColourApp, 'nothing', 10000);

    persistentCheck('.BIS_trigger',0,notifyApp,'nothing',10000);

  }

  changeProductByVariantID();
  accordionToggle();
  sizeguideSelect();
  sizeguideModal();

  return Product;
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');

	if ($(this).hasClass('address-new-primary')) {
		$(this).addClass('hide');
	}

	if ($(this).hasClass('address-new-secondary')) {
		$('.address-new-primary').removeClass('hide');
	}

  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');

	if ($(this).hasClass('address-edit-primary')) {
		$(this).addClass('hide');
	}

	if ($(this).hasClass('address-edit-secondary')) {
		$('.address-edit-primary').removeClass('hide');
	}
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

//create Cookie
function setCookie(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

//Get cookie value
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

//Delete cookie
function eraseCookie(name) {
	document.cookie = name+'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
}


function collectionReadMore() {
	var readmoreBtn = $('.collection-read-more'),
		collectionDescription = $('.collection-header .rte'),
		collectionDescriptionHeight = collectionDescription.height(),
		collectionNav = $('.collection-header .collection-sub-nav'),
		collectionNavHeight = collectionNav.height();

	readmoreBtn.off('click').on('click', function(e) {

		if (readmoreBtn.hasClass('active')) {

			collectionNav.animate({
				height: collectionNavHeight
			}, 1000);

			collectionDescription.removeClass('active');

			collectionDescription.animate({
				height: collectionDescriptionHeight
			}, 1000, function(){
				readmoreBtn.removeClass('active');
			});

			readmoreBtn.text('Read More');

		} else {

			collectionNav.animate({
				height: collectionNav.get(0).scrollHeight
			}, 1000, function(){
				$(this).height('auto');
			});

			collectionDescription.addClass('active');

			collectionDescription.animate({
				height: collectionDescription.get(0).scrollHeight
			}, 1000, function(){
				$(this).height('auto');
				readmoreBtn.addClass('active');
			});

			readmoreBtn.text('Read Less');

		}

	});
}

function collectionViews() {
	var collectionViewSelect = $('.collection-view li'),
		collectionView = $('#bc-sf-filter-products');

	if (getCookie('collectionView')) {
		collectionView.attr('class','row collection-view-six');
		collectionViewSelect.removeClass('active');
		$('.collection-view li.collection-view-six').addClass('active');
	}

	collectionViewSelect.click(function(){
		var collectionViewClass = $(this).attr('class').split(' ')[0];

		collectionViewSelect.removeClass('active');
		$(this).addClass('active');

		collectionView.attr('class','row '+collectionViewClass);

		if (collectionViewClass === 'collection-view-six' ) {
			setCookie('collectionView','six', 365)
		} else {
			eraseCookie('collectionView');
		}

	});
}

function filterToggle() {
	var filterTitle = $('.filter-title'),
		filterSidebar = $('.filter-sidebar');

	if ($(window).width() < screenLG) {
		filterTitle.removeClass('active');
		filterSidebar.css('display', '');
	}

	filterTitle.off('click').on('click', function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			filterSidebar.slideUp();
		} else {
			$(this).addClass('active');
			filterSidebar.slideDown();
		}
	});
}

//Get URL Parameters
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//On the initial page load, set the sorting option to the first option.
function sortFilter() {
	//if (!getUrlParameter('sort')) {
		$( window ).one( "load", function() {
			$('#bc-sf-filter-top-sorting select option:first').attr("selected",true);
		});
	//}
}

//BG: Changing the method of adding a second image. Rather than loading in the image as default, i'm loading in the URL to the second image, and will load it on hover.
function collectionProductHover() {
	$('.collection-listing #product_single .product-image-hover img').on("mouseenter", function(){
		var firstImage = $(this).attr('src'),
			secondImage = $(this).attr('data-second-image');

			$(this).attr('src',secondImage);
			$(this).attr('data-second-image',firstImage);
	});
	$('.collection-listing #product_single .product-image-hover img').on("mouseleave", function(){
		var secondImage = $(this).attr('src'),
			firstImage = $(this).attr('data-second-image');

			$(this).attr('src',firstImage);
			$(this).attr('data-second-image',secondImage);
	});
}

collectionReadMore();
collectionViews();
filterToggle();
sortFilter();

$(window).on('resize',function() {
	filterToggle();
});
//Update the quantity field on the cart page. Based on plus and minus buttons.
function cartQuantity() {
	var cartQuantity = $('.cart-product-quantity');


	cartQuantity.each(function(){
		var quantityUp = $(this).find('.quantity-up'),
			quantityDown = $(this).find('.quantity-down'),
			quantityValue = $(this).find('.cart-item__qty');


		quantityUp.on('click',function(){

			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal)) {
				quantityValue.val(currentVal + 1);
			}
			$('.btn-cart-update').click();
		});
		quantityDown.on('click',function(){
			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal) && currentVal > 1) {
				quantityValue.val(currentVal - 1);
			}
			$('.btn-cart-update').click();
		});

		quantityValue.bind('input',function() {
			$('.btn-cart-update').click();
		});
	});

}


function cartQuantitySelect() {
	var cartQuantity = $('.cart-product-quantity');

	cartQuantity.each(function(){
		var quantitySelect = $(this).find('.cart-product-quantity-select'),
			quantityValue = $(this).find('.cart-product-quantity-value').attr('value'),
			quantityInput = $(this).find('.cart-product-quantity-value');

		//On initial load, set the dropdown to reflect the current quantity.
        quantitySelect.find('[value="'+quantityValue+'"]').attr('selected', true);

        // LM Once quantity has been changed, need to update input value beneath so checkout quanity is updated as well.
        quantitySelect.on('change', function(){
            var selectedValue = $(this).find(':selected').attr('value');
            var selectedInput = $(this).next();

            $(selectedInput).attr('value', selectedValue);
        });

	});
}

//cartQuantity();
cartQuantitySelect();
function forgotPassword() {

	var loginForm = $('#CustomerLoginForm'),
		passwordForm = $('#RecoverPasswordForm');

	$('.show-forgot-password').click(function(){
		loginForm.addClass('hide');
		passwordForm.removeClass('hide');
	});

	$('.hide-forgot-password').click(function(){
		loginForm.removeClass('hide');
		passwordForm.addClass('hide');
	});
}

function resetPasswordForm() {
	var formState = $('.reset-password-success')

	if (formState.length) {
		$('#ResetSuccess').removeClass('hide');
	}
}

function myAccount() {
	var myOrders =  $('.template-account a.account-my-order'),
		allOrders = $('.template-account .account-my-orders');

	$(myOrders).click(function(e){
		e.preventDefault();
		if (myOrders.hasClass('active')) {
			$(allOrders).slideUp( "slow", function() {
				myOrders.removeClass('active');
			});
		} else {
			$(allOrders).slideDown( "slow", function() {
				myOrders.addClass('active');
			});
		}
	});
}

function getUrlParameter(url, parameter) {
    parameter = parameter.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?|&]' + parameter.toLowerCase() + '=([^&#]*)');
    var results = regex.exec('?' + url.toLowerCase().split('?')[1]);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function emailAutofil() {
    var email = getUrlParameter(window.location.href,'email'),
        emailInput = document.querySelector('#Email');

    if (email != "") {
        emailInput.value = email;
    }
}


forgotPassword();
resetPasswordForm();
myAccount();

if ($('body').hasClass('template-register')) {
    emailAutofil();
}

/*================ Sections ================*/
// Used with sections/header-text-features.liquid
function textFeaturesSlick() {
	$slick_slider = $('.text-features-slick');
	slicksettings = {
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'/></svg></button>",
		nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'/></svg></button>",
		responsive: [
		  {
			breakpoint: 768,
			settings: {
			  slidesToShow: 2
			}
		  },
		  {
			breakpoint: 576,
			settings: {
			  slidesToShow: 1
			}
		  }
		]
	}

	if ($(window).width() < screenLG) {
		$slick_slider.slick(slicksettings);
	}

	// reslick only if it's not slick()
	$(window).on('resize', function() {
	   if ($(window).width() > screenLG) {
	 	if ($slick_slider.hasClass('slick-initialized')) {
	 	  $slick_slider.slick('unslick');
	 	}
	 	return
	   } else {
	 	  if (!$slick_slider.hasClass('slick-initialized')) {
	 		return $slick_slider.slick(slicksettings);
	 	  }
	   }
	});
}

$(document).ready(function() {
    textFeaturesSlick();
});
//Open and close the mobile Search
function siteSearch() {
	const searchIcon = document.querySelector('#site-header .header-search-icon .icon-search'),
		  desktopSearch = document.querySelector('#site-header .header-search-icon input[type="search"]'),
		  searchForm = document.querySelector('#site-header .header-search-icon .site-search');

	var searchAction = 0;

	searchIcon.addEventListener("click", function(){
		if (searchAction == 1) {
			desktopSearch.focus();
			searchForm.submit();
		} else {
			desktopSearch.focus();
			searchAction++;
		}

	});

	desktopSearch.addEventListener("blur", function(){
		searchAction = 0;
	});
}

//Toggle open and close of mobile navigation
function mobileNavigationMenuToggle() {
	var menuIcon = $('#site-header .header-mobile-menu'),
		menu = $('#site-navigation'),
		overlay = $('.nav-overlay');

	menuIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			menu.removeClass('active');
			overlay.removeClass('active');
			$('body').removeClass('nav-push');

		} else {
			$(this).addClass('active');
			menu.addClass('active');
			overlay.addClass('active');
			$('body').addClass('nav-push');
		}
	});

	overlay.click(function() {
		$(this).removeClass('active');
		menu.removeClass('active');
		menuIcon.removeClass('active');
		$('body').removeClass('nav-push');
	})
}

//Toggle open and close of the individual links within the navigation.
function mobileNavigation() {
	var parentLink = $('#site-navigation .has-child > a');

	if ($(window).width() <= screenLG) {
		//console.log('screenSM and Lower');

		//unbind and bind click action - can cause issues when resizing browser
		parentLink.off('click').on('click', function(e) {
			//print anchor from working.
			e.preventDefault();

			//add active class to parent and slide down child menus.
			if ($(this).parent('li').hasClass('active')) {
				$(this).parent('li').removeClass('active');
				$(this).next('.sub-menu').slideUp();
			} else {
				parentLink.parent('li').removeClass('active');
				parentLink.next('.sub-menu').slideUp();
				$(this).parent('li').addClass('active');
				$(this).next('.sub-menu').slideDown();
			}
		});

		$('#site-navigation').addClass('transition');

	} else {
		parentLink.off('click');
		parentLink.next('.sub-menu').css('display', '');

		$('#site-navigation').removeClass('active transition');
		$('.nav-overlay').removeClass('active');
		$('#header .header-mobile-search-icon').removeClass('active');
		//console.log('greater than screenSM');

	}
}

function desktopNavigation() {
	var mainNavigation = $('#site-navigation'),
		parentLink = $('#site-navigation .has-child');

	if ($(window).width() >= screenLG) {
		//console.log('Screen LG & Greater');

		parentLink.on("mouseover", function() {
			$(this).addClass('active');
			$(this).find('.menu').addClass('active');
		});

		parentLink.on("mouseout", function() {
			$(this).removeClass('active');
			$(this).find('.menu').removeClass('active');
		});


	} else {
		//console.log('Lower than Screen LG');
		mainNavigation.off("mouseover");
		mainNavigation.off("mouseout");
		parentLink.off("mouseover");
	}
}

//BG: just for sorelle, when clicking the text feature link, and if it contains a hash, slide down to the respected section.
function uspBannerClick() {
    var textFeatureHeading = $('.text-feature-heading a');

        textFeatureHeading.on('click', function(e){
            if (/#/.test(this.href)) {
                e.preventDefault();
                var linkURL = $(this).attr('href');

                $([document.documentElement, document.body]).animate({
                    scrollTop: $(linkURL).offset().top
                }, 2000);
            }
        });
}

function headroom() {
	// grab an element
	var myElement = document.querySelector("header");
	// construct an instance of Headroom, passing the element
	var headroom  = new Headroom(myElement, {
		"offset": 200,
		"tolerance": 5
	});
	// initialise
	headroom.init();
}

//BG: Calculate the height of the header and apply it to the USP Banner as padding
function headerHeight() {
	var siteHeader = document.querySelector("#site-header").offsetHeight,
		  uspBanner = document.querySelector(".header-text-features");

	//16 represents 1rem
	uspBanner.style.paddingTop = 16 + siteHeader + 'px';
}

$(document).ready(function() {
    siteSearch();
    mobileNavigationMenuToggle();
    mobileNavigation()
	desktopNavigation();
	headroom();
    headerHeight();
    uspBannerClick();
});

$(window).on('resize',function() {
    mobileNavigation();
	desktopNavigation();
	headerHeight();
});
function footerLinks() {
	var footerTitle = $('footer .footer-title'),
		footerContent = $('footer .footer-content');

	if ($(window).width() <= screenSM) {

		footerTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.footer-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.footer-content').slideDown();
			}
		});

	} else {
		footerTitle.off('click');
		footerContent.css('display', '');
	}
}

function newsletterForm() {
    var newsletter = document.querySelector('.newsletter-account');

    // Check if the element exists before adding event listener
    if (!newsletter) {
        return; // Exit early if element doesn't exist
    }

    newsletter.addEventListener('submit', function(e){
        e.preventDefault();
        
        var emailInput = this.querySelector('.email');
        
        // Additional check for email input
        if (!emailInput) {
            return;
        }
        
        var email = emailInput.value.trim(); // Use trim() to remove whitespace

        if (email !== "") {
            window.location = '/account/register?email=' + encodeURIComponent(email);
        }
    });
}

footerLinks();
newsletterForm();

$(window).on('resize',function() {
    footerLinks();
});

/*================ Snippets ================*/


$(document).ready(function() {


  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }





});

/* ==========================================================================
#Custom Velstar
========================================================================== */


//product page swatch change
$('.swatch :radio').change(function() {
	var optionIndex = $(this).closest('.swatch').attr('data-option-index');
	var optionValue = $(this).val();
	$(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});
